import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { GaranLogService } from 'src/app/core/garan-log.service';
import { IntegrationCall, IntegrationCallService } from 'src/app/core/integration-call.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-orders-requests-dialog',
  templateUrl: './orders-requests-dialog.component.html',
  styleUrls: ['./orders-requests-dialog.component.scss'],
})
export class OrdersRequestsDialogComponent {
  is_list_requests_running: boolean = false;
  buyer_id?: string;
  order_id?: string;
  integration_calls?: IntegrationCall[];

  constructor(
    private dialog_ref: MatDialogRef<OrdersRequestsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private garan_log_service: GaranLogService,
    private integration_call_service: IntegrationCallService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
  ) {
    this.buyer_id = data.buyer_id;
    this.order_id = data.order_id;
  }

  ngOnInit(): void {
    if (this.buyer_id) {
      this.createGaranLog(this.buyer_id);
    }

    if (this.order_id) {
      this.listIntegrationCall(this.order_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  listIntegrationCall(order_id: string): void {
    this.is_list_requests_running = true;
    this.integration_call_service.list(order_id).subscribe({
      next: response => {
        this.integration_calls = response.data;
        this.is_list_requests_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_list_requests_running = false;
      },
    });
  }

  createGaranLog(buyer_id: string): void {
    const admin_email = this.utils_service.getProfileEmail();
    this.garan_log_service.create(buyer_id, admin_email).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  getParsedJSON(raw?: string, type?: string): any {
    if (!raw) return '';
    if (type == 'qnetic-create-position') {
      return JSON.parse(JSON.parse(raw));
    }
    return JSON.parse(raw);
  }
}
